import { render } from "./AlarmDisplay.vue?vue&type=template&id=6f6e31b0"
import script from "./AlarmDisplay.vue?vue&type=script&lang=js"
export * from "./AlarmDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__